/**
 * Parsed France coordinates for geoSearch refinement
 * Format: { northEast: { lat, lng }, southWest: { lat, lng } }
 */
export const FRANCE_GEO_BOUNDS = {
  northEast: {
    lat: 52.526157916110805,
    lng: 8.104930738777426
  },
  southWest: {
    lat: 36.38341995380996,
    lng: -4.525929595910526
  }
}

/**
 * Default France geographical bounding box coordinates
 * Latitude/Longitude format: [maxLat, maxLng, minLat, minLng]
 * This represents the bounding box of mainland France
 */
export const FRANCE_GEO_SEARCH = `${FRANCE_GEO_BOUNDS.northEast.lat},${FRANCE_GEO_BOUNDS.northEast.lng},${FRANCE_GEO_BOUNDS.southWest.lat},${FRANCE_GEO_BOUNDS.southWest.lng}`
